import { flow, types } from 'mobx-state-tree';
import { onSnapshot } from 'mobx-state-tree';
import { axiosRequest, CustomErrorModel } from 'shared/api';
import { SpecializationApiResponse } from './types';

export const SpecializationModel = types.model({
	id: types.number,
	name: types.string,
	order: types.number,
});

export const SpecializationsStore = types
	.model('SpecializationsStore', {
		specializations: types.array(SpecializationModel),
		loading: types.boolean,
		error: types.maybeNull(CustomErrorModel),
	})
	.actions(self => ({
		fetchSpecializations: flow(function* () {
			self.loading = true;
			try {
				const response: SpecializationApiResponse = yield axiosRequest({
					path: '/api/v2/booking/specialization',
				});

				if (response?.results) {
					const results = response.results.sort((a, b) =>
						a.name.localeCompare(b.name),
					);
					self.specializations.replace(results);
				}
				self.loading = false;
			} catch (error) {
				console.error('Error fetching specializations:', error);
				self.error = error as any;
				self.loading = false;
			}
		}),
    getSpecializations: (query: string) => {
      const filtered = self.specializations.filter(el=>el.name.toLowerCase().includes(query.toLowerCase()))
      return filtered;
    }
	}));

export const specializationsStore = SpecializationsStore.create({
	specializations: [],
	error: null,
	loading: false,
});

//Если нужно дебажить
onSnapshot(specializationsStore, snapshot => {
  if (import.meta.env.VITE_SHOW_SNAPSHOT !== 'false') {
    console.log('Снимок состояния:', snapshot);
  }
});

// onAction(documentsStore, action => {
// 	console.log("Экшен", action);
// })
